module.exports = __webpack_public_path__ + "static/media/gy.bdf44d24.svg";